export enum Channel {
  Online = 'ONLINE',
  Phone = 'PHONE',
}
